import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNavigationStore = defineStore('navigation', () => {
  // State
  const navigationSource = ref<'internal' | 'external'>('external')

  // Actions
  const setNavigationSource = (source: 'internal' | 'external') => {
    navigationSource.value = source
  }

  return {
    navigationSource,
    setNavigationSource
  }
})

export type NavigationStore = ReturnType<typeof useNavigationStore>
